import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { APIClient } from "../../helpers/api_helper";
import * as URL from "../../helpers/url_helper";

const api = new APIClient();

export const fetchPipelineStages = createAsyncThunk(
  "pipeline/fetchStages",
  async () => api.get(URL.GET_PIPELINE_STAGES)
);

export const createPipelineStage = createAsyncThunk(
  "pipeline/createStage",
  async (stage) => api.create(URL.ADD_PIPELINE_STAGE, stage)
);

export const updatePipelineStage = createAsyncThunk(
  "pipeline/updateStage",
  async ({ id, data }) => api.put(`${URL.UPDATE_PIPELINE_STAGE}/${id}`, data)
);

export const deletePipelineStage = createAsyncThunk(
  "pipeline/deleteStage",
  async (id) => { await api.delete(`${URL.DELETE_PIPELINE_STAGE}/${id}`); return id; }
);

const slice = createSlice({
  name: "pipeline",
  initialState: { stages: [], loading: false, error: null },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchPipelineStages.pending, (s) => { s.loading = true; });
    b.addCase(fetchPipelineStages.fulfilled, (s, a) => {
      s.loading = false;
      s.stages = (a.payload || []).slice().sort((x, y) => (x.position ?? 0) - (y.position ?? 0));
    });
    b.addCase(fetchPipelineStages.rejected, (s, a) => { s.loading = false; s.error = a.error.message; });
    b.addCase(createPipelineStage.fulfilled, (s, a) => {
      if (a.payload) s.stages = [...s.stages, a.payload].sort((x, y) => (x.position ?? 0) - (y.position ?? 0));
    });
    b.addCase(updatePipelineStage.fulfilled, (s, a) => {
      if (!a.payload) return;
      s.stages = s.stages.map((st) => st.id === a.payload.id ? a.payload : st);
    });
    b.addCase(deletePipelineStage.fulfilled, (s, a) => {
      s.stages = s.stages.filter((st) => st.id !== a.payload);
    });
  }
});

export default slice.reducer;
